// src/features/orders/OrdersPage.tsx
import { useState } from 'react';
import { GlassCard } from '../../app/components/ui/GlassCard';
import { OrderList } from './components/OrderList';
import { OrderListEmptyState } from './components/OrderListEmptyState';
import { OrderListSkeleton } from './components/OrderListSkeleton';
import { OrdersHeader } from './components/OrdersHeader';
import { OrdersToolbar } from './components/OrdersToolbar';
import { OrderWorkspace } from './components/OrderWorkspace';
import { useOrders } from './hooks/useOrders';
import type { Order } from './types/orders.types';

export function OrdersPage() {
  const { orders, isLoading, isEmpty } = useOrders();
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <OrdersHeader orders={orders} isLoading={isLoading} />
      <OrdersToolbar />

      <GlassCard noPadding>
        {isLoading ? (
          <OrderListSkeleton />
        ) : isEmpty ? (
          <OrderListEmptyState />
        ) : (
          <OrderList
            orders={orders}
            selectedOrderId={selectedOrder?.id ?? null}
            onSelectOrder={setSelectedOrder}
          />
        )}
      </GlassCard>

      <OrderWorkspace order={selectedOrder} onClose={() => setSelectedOrder(null)} />
    </div>
  );
}
